import { render, staticRenderFns } from "./AdminDashboard.vue?vue&type=template&id=5aaf6dde&scoped=true"
import script from "./AdminDashboard.vue?vue&type=script&lang=js"
export * from "./AdminDashboard.vue?vue&type=script&lang=js"
import style0 from "./AdminDashboard.vue?vue&type=style&index=0&id=5aaf6dde&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5aaf6dde",
  null
  
)

export default component.exports